import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Tippy from '@tippyjs/react/headless';
import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'tooltip'
});
var arrowPath = getVariantPath({
  id: 'tooltip',
  element: 'arrow'
}); // Inversing tooltip placement values since arrows need to be on the oposite side of the container

var arrowPlacementMap = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right'
};

var Arrow = function Arrow(_ref) {
  var placement = _ref.placement,
      props = _objectWithoutProperties(_ref, ["placement"]);

  return _jsx("div", _objectSpread({
    sx: {
      variant: arrowPath(placement)
    }
  }, props));
};

var TooltipContent = function TooltipContent(text, attrs) {
  return _jsxs("div", _objectSpread(_objectSpread({
    sx: {
      variant: variantPath()
    }
  }, attrs), {}, {
    children: [text, _jsx(Arrow, {
      placement: attrs['data-placement'] ? arrowPlacementMap[attrs['data-placement']] : 'bottom',
      "data-popper-arrow": true
    })]
  }));
};

export var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var content = _ref2.content,
      position = _ref2.position,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["content", "position", "children"]);

  return _jsx(Tippy, _objectSpread(_objectSpread({
    tabindex: 0,
    ref: ref,
    placement: position,
    arrow: true,
    trigger: "click",
    render: function render(attrs) {
      return TooltipContent(content, attrs);
    }
  }, props), {}, {
    children: children
  }));
});
Tooltip.propTypes = {
  /**
   * Text to display in the tooltip
   */
  content: PropTypes.node,

  /**
   * Tooltip position
   */
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Component to show the tooltip over
   */
  children: PropTypes.node
};
Tooltip.defaultProps = {
  content: '',
  position: 'top'
};